export var UploadStatus = /*#__PURE__*/function (UploadStatus) {
  UploadStatus[UploadStatus["Waiting"] = 0] = "Waiting";
  UploadStatus[UploadStatus["Uploading"] = 1] = "Uploading";
  UploadStatus[UploadStatus["Error"] = 2] = "Error";
  return UploadStatus;
}({});